import React from 'react'
import classnames from 'classnames/bind'

import GradientHeader from 'components/shared/GradientHeader'
import ImageCard from 'components/shared/ImageCard'
import Question from './Question'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export default function Interview({
  introImage,
  gradientHeader,
  questionAnswer,
  className,
}) {
  return (
    <section className={cx(css.Interview, className)}>
      <GradientHeader {...gradientHeader}>
        {introImage && <ImageCard {...introImage} />}

        {questionAnswer && (
          <div className={css.wrapper}>
            {questionAnswer.map(({ question, answer, id }, index) => {
              const shouldRender = question && answer

              return shouldRender ? (
                <Question
                  key={id}
                  index={index}
                  title={question}
                  answer={answer}
                  className={css.question}
                />
              ) : null
            })}
          </div>
        )}
      </GradientHeader>
    </section>
  )
}
